import React from 'react';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next/';
import { FormControl, InputAdornment, makeStyles, TextField } from '@material-ui/core';
import { MaterialEditFormInterface, SubMaterial } from 'types';
import { fonts } from 'theme';
import { sanitizeAlphaNumericAndSpecial } from 'utils/formatter';
import { TrashIcon } from 'components/Icons';

const useSubMaterialItemStyles = makeStyles({
  rowSubMaterial: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: '10px',
    width: '100%',
    height: '35px',
    '> div': {
      borderBottom: 'none',
      fontFamily: fonts.secondary,
      '&:first-child': {
        paddingLeft: '34px',
      },
    },
  },
  cellStyleSubMaterial20: {
    width: '20%',
    padding: '0 25px',
    fontWeight: 'bold',
  },
  cellStyleSubMaterial35: {
    width: '35%',
    paddingLeft: '25px',
  },
  iconPointer: {
    cursor: 'pointer',
  },
});

type SubMaterialItemProps = {
  subMaterial: SubMaterial;
  index: number;
  isEditing: boolean;
  control: Control<MaterialEditFormInterface, object>;
  setValue: UseFormSetValue<MaterialEditFormInterface>;
  handleDeleteSubMaterial: (subMaterialId: SubMaterial, index: number) => void;
  isSubMaterial: boolean;
};

const SubMaterialItem: React.FC<SubMaterialItemProps> = ({
  subMaterial,
  index,
  isEditing,
  control,
  setValue,
  handleDeleteSubMaterial,
  isSubMaterial,
}) => {
  const classes = useSubMaterialItemStyles();
  const { t: pt } = useTranslation('translation', { keyPrefix: 'materials' });

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(`subMaterials.${index}.name`, sanitizeAlphaNumericAndSpecial(e.target.value));
  };

  return (
    <div className={classes.rowSubMaterial} key={subMaterial['@id']}>
      <div className={classes.cellStyleSubMaterial20}>{index === 0 ? pt('subMaterial.title') : ''}</div>
      {isEditing && isSubMaterial ? (
        <FormControl className={classes.cellStyleSubMaterial35}>
          <Controller
            name={`subMaterials.${index}.name`}
            control={control}
            render={({ field: { ref, ...fieldProps }, fieldState }) => (
              <TextField
                id={`subMaterials.${index}.name`}
                inputRef={ref}
                {...fieldProps}
                helperText={fieldState.error?.message}
                error={fieldState.invalid}
                onChange={onChangeName}
                InputProps={{
                  endAdornment: !subMaterial.hasCharacterizationSubMaterial && (
                    <InputAdornment
                      className={classes.iconPointer}
                      position="end"
                      onClick={() => handleDeleteSubMaterial(subMaterial, index)}
                    >
                      <TrashIcon width={24} height={24} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </FormControl>
      ) : (
        <div className={classes.cellStyleSubMaterial35}>{subMaterial.name}</div>
      )}
    </div>
  );
};

export default SubMaterialItem;
